import {message} from 'antd'
export const HOCWithMessageHandler = (WrappedComponent) => {
  return  (props) => {
    const [messageApi, contextHolder] = message.useMessage();
    
    return (
      <>
        {contextHolder}
        <WrappedComponent messageApi={messageApi} {...props}/>
      </>
    );
  
  }
}